// Translate at render time so an open error follows the selected app language.
export function formatCertificateError(message, t, language = 'es') {
  if (typeof message !== 'string') return message;
  return message.replace(
    /Certificate expired on ([^\s]+)\. \[CERTIFICATE_EXPIRED:(user|group|org|platform):([^\]]+)\]/g,
    (original, displayedDate, source, rawDate) => {
      const value = new Date(rawDate);
      if (!Number.isFinite(value.getTime())) return original;
      const date = new Intl.DateTimeFormat(language, {
        day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'
      }).format(value);
      return t(`cert-mgmt.expired-${source}`, { date });
    }
  );
}
